import { cn } from "@/lib/utils";

interface MetricCardProps {
  label: string;
  value: string | number;
  unit?: string;
  expectedRange?: string;
  outOfRange?: boolean;
  className?: string;
}

export function MetricCard({
  label,
  value,
  unit,
  expectedRange,
  outOfRange,
  className,
}: MetricCardProps) {
  return (
    <div
      className={cn(
        "bg-white rounded-[var(--card-radius)] p-[var(--space-md)] shadow-sm",
        outOfRange && "ring-1 ring-copilot-critical-border bg-copilot-critical-bg",
        className
      )}
    >
      <div className="text-xs font-medium text-copilot-text-secondary mb-1">
        {label}
      </div>
      <div
        className={cn(
          "text-2xl font-bold text-copilot-text-primary",
          outOfRange && "text-copilot-critical"
        )}
      >
        {value}
        {unit && (
          <span className="text-sm font-normal text-copilot-text-secondary ml-0.5">
            {unit}
          </span>
        )}
      </div>
      {expectedRange && (
        <div
          className={cn(
            "text-xs mt-1",
            outOfRange ? "text-copilot-critical" : "text-copilot-text-tertiary"
          )}
        >
          {expectedRange}
        </div>
      )}
    </div>
  );
}
